import { render, staticRenderFns } from "./rowitem.vue?vue&type=template&id=d1342a54&scoped=true"
import script from "./rowitem.vue?vue&type=script&lang=js"
export * from "./rowitem.vue?vue&type=script&lang=js"
import style0 from "./rowitem.vue?vue&type=style&index=0&id=d1342a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1342a54",
  null
  
)

export default component.exports